import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import moment from "moment";

import Stars from '../../../Common/Stars';
import { constants } from '../../../../Helpers/Constants';
import { DivisionIcon, VCIcon } from '../../../Common/Buttons/TypeIcons';
import VehicleCell from '../Vehicle/VehicleCell';
import { ActivityActive, ActivityInactive, CalendarUncoloured, VCDefault, ServiceDefault, VehicleIncoming } from '../../../Common/Buttons/Icons';

class VehicleTiersRow extends Component {
    constructor(props) {
        super(props);

        this.renderVehicleOptions = this.renderVehicleOptions.bind(this);

        this.state = {
        };
    }

    componentDidMount() {
    }

    setRowClass(vehicle) {
        var className;

        if (vehicle.Active === 1) {
            if ('bookings_made_last_three_months' in vehicle && vehicle.bookings_made_last_three_months.length > 0) {
                className = "row-active"
            } else if ('bookings_made_last_three_months' in vehicle && vehicle.bookings_made_last_three_months.length === 0 && moment(vehicle.Available_Date, "YYYY-MM-DD").startOf('day').isBefore(moment().subtract(90, 'days').startOf('day'))) {
                className = 'row-inactive'
            }
        } else {
            className = 'row-grey'
        }

        return className;
    }

    setVehicleLocationIcon(vehicle) {
        if (vehicle.Active === -1) {
            return(
               RetireListView() 
            )
        } else if (vehicle.status === 'Vehicle Center') {
            return(
                VCDefault()
            )
        } else if (vehicle.status === 'Service') {
            return(
                ServiceDefault()
            )
        } else if (vehicle.status === 'Incoming') {
            return(
                VehicleIncoming()
            )
        } else if (vehicle.status === 'On Booking') {
            return(
                CalendarUncoloured()
            )
        }
    }

    setBookingActivityIcon(vehicle) {
        if ('bookings_made_last_three_months' in vehicle && vehicle.bookings_made_last_three_months.length > 0) {
            return(ActivityActive())
        } else if(moment(vehicle.Available_Date, "YYYY-MM-DD").startOf('day').isBefore(moment().subtract(90, 'days').startOf('day'))) {
            return(ActivityInactive())
        }

        return (<img src = "images/png-icons/dash-grey.png"/>)
    }

    renderVehicleOptions(vehicle) {
        if (vehicle.Active === 1) {
            return(
                <div className = "list-action-dropdown">
                    <ul>
                        <li onClick={() => this.editVehicle(vehicle.V_ID)}>
                            <img src="images/png-icons/edit-blue.png" className = "float-left mr-8"/><span className = "float-left">Edit</span>
                            <div className = "clearfix"></div>
                        </li>
                        <li onClick={() => this.addReminder(vehicle.V_ID)}>
                            <img src="images/png-icons/addreminder-blue.png" className = "float-left mr-8"/><span className = "float-left">Add Reminder</span>
                            <div className = "clearfix"></div>
                        </li>
                        <li onClick={() => this.retireVehicle(vehicle.V_ID)}>
                            <img src="images/png-icons/retirevehicle-red.png" className = "float-left mr-8"/><span className = "float-left">Retire</span>
                            <div className = "clearfix"></div>
                        </li>
                    </ul>
                </div>
            )
        } else {
            return(
                <div className = "list-action-dropdown">
                    <ul>
                        <li onClick={() => this.editVehicle(vehicle.V_ID)}>
                            <img src="images/png-icons/edit-blue.png" className = "float-left mr-8"/><span className = "float-left">Edit</span>
                            <div className = "clearfix"></div>
                        </li>
                        
                        {/*<li>
                            <img src="images/png-icons/addvehicle-green.png" className = "float-left mr-8"/><span className = "float-left">Unretire</span>
                            <div className = "clearfix"></div>
                        </li>
                        */}
                    </ul>
                </div>
            )
        }
    }

    render() {
        return (
            <tr className={this.setRowClass(this.props.vehicle)}>
                <td>
                    <VehicleCell history={this.props.history} match={this.props.match} location={this.props.location} vehicle={this.props.vehicle} key={this.props.vehicle.V_ID} showType={false} noTooltip/>
                </td>
                <td className = "single-img-cell align-center">
                    {this.setVehicleLocationIcon(this.props.vehicle)}
                </td>
                <td className = "single-img-cell align-center">
                    {this.setBookingActivityIcon(this.props.vehicle)}
                </td>
                <td className = "multi-img-cell px-26 align-center">
                    {DivisionIcon(this.props.vehicle.stakeholder, undefined, undefined, undefined, true)}
                </td>
                <td className = "multi-img-cell px-26 align-center">
                    {VCIcon(this.props.vehicle.vmh, undefined, undefined, undefined, true)}
                </td>
                <td className = "single-img-cell">
                    {
                        'utilization' in this.props.vehicle ? 
                            <span>{this.props.vehicle.utilization.utilization}%</span>
                        :
                            <img src = "images/png-icons/dash-grey.png"/> 
                    }
                </td>
                <td className = "single-img-cell">
                    {
                        'utilization' in this.props.vehicle ? 
                            <span>{new Intl.NumberFormat('en-CA').format(this.props.vehicle.Odometer)} KM</span>
                        :
                            <img src = "images/png-icons/dash-grey.png"/> 
                    }
                </td>
                <td className = "single-img-cell">
                    {
                        'utilization' in this.props.vehicle ? 
                            <span>{this.props.vehicle.utilization.total_bookings}</span>
                        :
                            <img src = "images/png-icons/dash-grey.png"/> 
                    }
                </td>
                <td className = "single-img-cell">
                    {
                        'last_booking' in this.props.vehicle && this.props.vehicle.last_booking !== null ?
                            moment(this.props.vehicle.last_booking.End_Date, "YYYY-MM-DD").format("MMM DD, YYYY")
                        :
                            <img src = "images/png-icons/dash-grey.png"/> 
                    }
                </td>
                <td>
                {
                    this.props.vehicle.V_ID in this.props.data.vehicle_db && "tier" in this.props.data.vehicle_db[this.props.vehicle.V_ID] && this.props.data.vehicle_db[this.props.vehicle.V_ID].tier.length > 0 > 0 ?
                        <Stars star={this.props.data.vehicle_db[this.props.vehicle.V_ID].tier[0].Rank} type={"Vehicle"} ID={this.props.vehicle.V_ID} key={"star_" + this.props.vehicle.V_ID} mutable={this.props.vehicle.has_authorizing ? "mutable" : ""} confirmable/>
                    :
                        "tier" in this.props.vehicle && this.props.vehicle.tier.length > 0 ?
                            <Stars star={this.props.vehicle.tier[0].Rank} type={"Vehicle"} ID={this.props.vehicle.V_ID} key={"star_" + this.props.vehicle.V_ID} mutable={this.props.vehicle.has_authorizing ? "mutable" : ""} confirmable/>
                        :
                            null
                }
                </td>
            </tr>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data
})

export default connect(mapStateToProps)(VehicleTiersRow)